import bus from '@/plugins/bus'

const instance = {

    init() {
        //подписываемся на событие необходимости показа локального уведомления
        bus.on('OKRAINA_NOTIFICATION_E_SHOW', async (data) => {

            let arNotification = {
                title: data.TITLE,
                message: data.BODY,
                smallIcon: "fcm_push_icon",
                data: data,
            };

            if(data.ICON) {
                arNotification.largeIconUrl = data.ICON;
            } else {
                arNotification.largeIcon = "fcm_push_icon_large";
            }

            window.HmsLocalNotification.localNotification(arNotification);
        });

        //клик по локальному уведомлению
        window.HmsPushEvent.onLocalNotificationAction((result) => {
            console.log(JSON.stringify(result));
        });
    }

}

export default instance;